import useSWR from "swr";

import * as fetcher from "../fetcher";

const fetchInstallAvailability = async (url: string) => {
  const result = await fetcher.global.get<boolean>(url);

  return result;
};

export function useInstallAvailability(zipCode: string) {
  const { data, isValidating, isLoading } = useSWR<boolean>(
    zipCode ? `/salesforce/install/availability/${zipCode}` : null,
    fetchInstallAvailability,
    { shouldRetryOnError: false, revalidateOnFocus: false }
  );

  return {
    data,
    isValidating,
    isLoading,
  };
}
